import React from 'react';
import TacticSelectionSection from './TacticSelectionSection';
import { OFFENSIVE_TACTICS_OPTIONS } from '../../../constants/coachTactics';

/**
 * OFFENSIVE TACTICS — the half that never existed. The coach profile has always
 * asked how a team defends and never how it attacks, so half of the answer had
 * nowhere to go. Built as the twin of DefensiveTacticsSection: same body, same
 * behaviour, its own suggestion list, and its own field on the record
 * (`Coach.offensive_tactics`, `Staff.offensive_tactics`).
 */
const OffensiveTacticsSection = ({ isEditing, offensiveTactics = [], onUpdateOffensiveTactics }) => (
  <TacticSelectionSection
    isEditing={isEditing}
    values={offensiveTactics}
    onUpdate={onUpdateOffensiveTactics}
    options={OFFENSIVE_TACTICS_OPTIONS}
    title="OFFENSIVE TACTICS"
    addButtonLabel="+ Add Offensive Tactic"
    emptyLabel="No offensive tactics information available"
    modalTitle="ADD OFFENSIVE TACTIC"
    selectLabel="Select Offensive Tactic"
    selectPlaceholder="Select an offensive tactic"
    removeAriaLabel="Remove offensive tactic"
  />
);

export default OffensiveTacticsSection;
